import { memo, useId } from 'react';
import classnames from 'classnames';
import ReactSelect, { components, type DropdownIndicatorProps } from 'react-select';
import IconChevronDown from '@scramble/design-system/icons/chevron-down.svg';
import { RequiredMark } from '../../RequiredMark';
import type { SelectOption, SelectProps } from './types';
import s from './index.module.scss';

const DropdownIndicator = (props: DropdownIndicatorProps<SelectOption, false>) => (
  <components.DropdownIndicator {...props}>
    <img src={IconChevronDown} alt="" width={20} height={20} />
  </components.DropdownIndicator>
);

export const Select = memo(function Select({
  selected,
  label,
  name,
  isRequired = false,
  isSearchable = false,
  options,
  onChange,
  error,
  className,
  disabled,
  placeholder = '',
  ...props
}: SelectProps) {
  const inputId = useId();
  const errorId = useId();

  return (
    <div className={classnames(s.wrapper, className)}>
      {label && (
        <label htmlFor={inputId} className={s.label}>
          <span className="f-body-sm f-500">{label}</span>
          {isRequired && <RequiredMark hasError={!!error} />}
        </label>
      )}
      <ReactSelect<SelectOption, false>
        inputId={inputId}
        value={selected}
        onChange={onChange}
        name={name}
        classNamePrefix="scr_select"
        className={classnames(s.select, error && s.select_error)}
        options={options}
        components={{ DropdownIndicator }}
        placeholder={placeholder}
        menuPlacement="auto"
        isSearchable={isSearchable}
        isDisabled={disabled}
        aria-invalid={!!error}
        aria-errormessage={error ? errorId : undefined}
        {...props}
      />
      {error && (
        <div id={errorId} className={s.error_message}>
          {error}
        </div>
      )}
    </div>
  );
});
